module.exports = __webpack_public_path__ + "static/media/18ECA17.178db55f.jpg";